// src/Pages/Home.js
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Styles/Home.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <div className="home-container">
      <div className="blur-wrapper">
        {/* Hero / Introduction Section */}
        <div className="hero-wrapper">
          <section className="hero-section">
            <Navbar />
            <div className="hero-text">
              <div className="hero-title" data-aos="fade-in">
                <img
                  src="/robologo.png"
                  alt="RoboFication Logo"
                  className="logo-img"
                />
                <h1>RoboFication</h1>
              </div>
              <p>
                AI Agent as Sys<span className="fancy">tems Engineer</span>
              </p>
              <div className="hero-buttons">
                <button
                  className="glow-button"
                  onClick={() => navigate("/products")}
                >
                  Explore Our Tools
                </button>
                <button
                  className="glow-button"
                  onClick={() => navigate("/contact-us")}
                >
                  Contact Us
                </button>
              </div>
            </div>
            {/* Uncomment the video block below if needed */}
            {/* <div className="hero-image">
            <iframe
              className="video-embed"
              src="https://www.youtube.com/embed/mHcAsPCgyT0?autoplay=1&loop=1&playlist=mHcAsPCgyT0&mute=0&controls=0&modestbranding=1&rel=0&iv_load_policy=3"
              title="RoboFication: Your AI Systems Engineer"
              frameBorder="20"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div> */}
          </section>
        </div>

        {/* Section 1: The Challenge */}
        <div className="blue-container">
          <section className="text-section">
            <h2>The Challenge</h2>
            <p>
              Safety-critical industries, such as automotive, aerospace, and
              healthcare, are under increasing pressure to meet stringent
              regulatory standards while delivering innovative solutions faster
              than ever. Traditional systems engineering methods are heavily
              reliant on manual processes, which are error-prone,
              time-consuming, and difficult to scale. Managing complexity,
              ensuring traceability across the development lifecycle, and
              reducing human errors are persistent challenges that hinder
              efficiency, innovation, and compliance.
              <br />
              <br />
              This creates a pressing need for intelligent, automated solutions
              to streamline workflows and accelerate development without
              compromising safety or quality.
            </p>
            <div className="links-row">
              <a
                href="https://robofication.net"
                target="_blank"
                rel="noreferrer"
              >
                https://robofication.net
              </a>
              <a
                href="https://www.youtube.com/@RoboFication/videos"
                target="_blank"
                rel="noreferrer"
              >
                Watch our Video on YouTube
              </a>
            </div>
          </section>
          <section className="text-section">
            <h2>AI-Driven Solutions</h2>
            <p>
              Our AI-powered tools automate safety analysis, generate precise
              requirements, and ensure regulatory compliance. By leveraging
              advanced machine learning, we’re revolutionizing the way
              safety-critical systems are engineered.
            </p>
          </section>
        </div>

        {/* Section 3: Tool Description */}
        <section className="text-section-2">
          <h2>Explore Our Tools</h2>
          <div className="tooldesc">
            <div className="card">
              <h4>Robo HuddleRoom</h4>
              <p>
                Automating system description generation and hazard analysis
                from real-time communication.
              </p>
            </div>
            <div className="card">
              <h4>Robo SysML</h4>
              <p>Automatically generates SysML diagrams from your code.</p>
            </div>

            <div className="card">
              <h4>Robo Code Analyzer</h4>
              <p>
                Automates safety analysis and generates requirements directly
                from codebases.
              </p>
            </div>
            <div className="card">
              <h4>Robo Model Analyzer</h4>
              <p>
                Ensures system safety in model-based design with intelligent
                analysis.
              </p>
            </div>
            <div className="card">
              <h4>Robo Systems Engineer</h4>
              <p>
                Focused on real-time collaboration in a web-based interface.
              </p>
            </div>
          </div>
        </section>
      </div>
      {/* Section 4: Footer */}
      <Footer />
    </div>
  );
}

export default Home;
